// @flow
import client from '../../client'

// Types
import type { SuggestionLocation } from '../../models/location'

// API Endpoint
export const LOCATIONS_ENDPOINT = '/locations/stations/'

/**
 * Get airport suggestions from a potencially partial user input.
 * @param  {string} value A string to get suggestions from.
 * @return {Promise|Error} A Promise eventually resolving to the suggestions
 */
const getAirports = (query: string): Promise<Array<SuggestionLocation>> => {
  if (!query) {
    return Promise.reject(new Error('Query not provided'))
  }

  return client
    .get(LOCATIONS_ENDPOINT, { query: { query } })
    .then((x) => x.results || [])
}

export default getAirports
